'use client';

import { c as _c } from "react/compiler-runtime";
import RegistrationScreen from '@app/registration/(with-padding)/_basic/RegistrationScreen';
import { useSearchParams } from 'next/navigation';
import { ReactElement } from 'react';
function RegistrationContent() {
  const $ = _c(2);
  const searchParams = useSearchParams();
  const rawStep = searchParams?.get("step");
  const step = rawStep === "second" ? "second" : "first";
  let t0;
  if ($[0] !== step) {
    t0 = <RegistrationScreen step={step} />;
    $[0] = step;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export default RegistrationContent;